<template>
  <div>
    <div v-if="!addTeamFlag && !teamPermissionsFlag">
      <div class="col-sm-12 col-xs-12 col-md-12 pl-24 line-1 p-0">
        <hr />
      </div>
      <div class="col-md-12 col-sm-12 col-xs-12 mr-bt-10 team_member_count">
        <div class="row">
          <div
            class="col-md-6 col-sm-3 col-xs-3 team_member_found"
          >{{ $t('activeMembers')}}</div>
          <div class="col-md-6 col-sm-6 col-xs-6 d-flex-sm-end pr-17">
            <div class="d-flex">
              <button class="btn m-0 p-0 deselect-buttons btn-disabled deselect-button-color pl-12" :disabled="checkedValue.length < 2" @click="deselectAllCheckedValues">{{ $t('deselectAll')}}</button>
            </div>
            <div class="d-flex delete-button-color" v-if="loggedInUser.role_id === 1">
              <img class="info-img" src="/static/images/icons/change_role_icon.svg" :style="[(editRoleFlag || teamMemberCount <= 1)?{'opacity':'0.4'}:'']"/>
              <button class="btn deselect-buttons btn-disabled deselect-button-color m-0 p-0 pl-9" :disabled="editRoleFlag || teamMemberCount <= 1" @click="editRole">{{ $t('changeRole') }}</button>
            </div>
            <div class="d-flex delete-button-color pl-8">
              <img class="info-img" src="/static/images/icons/Headlines_Delete_icon.svg" :class="(checkedValue.length < 2) && 'disable-popup'" />
              <button class="btn deselect-buttons btn-disabled m-0 pl-5 delete-button-color" :disabled="checkedValue.length < 2" @click="openDeleteConfirmationPopup()">{{ $t('delete')}}</button>
            </div>
            <button class="btn add_team_member" @click="addTeamMemberSection" :disabled="editRoleFlag || roleId===2 || roleId===3">
              <img src="/static/images/icons/plus_icon.svg" />
              {{ $t('add')}}
              <span class="hidden-xs">{{ $t('member')}}</span>
            </button>
          </div>
        </div>
      </div>
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 pl-34">
        <search-box :teamBorder='true' v-model="searchValue" :searchCount="teamMemberCount" @getList="filterTeamsList"></search-box>
      </div>
      <div class="col-md-12 col-sm-12 col-xs-12 hidden-xs dotted pl-34">
        <div class="row member-box-wrapper">
          <div class="col-sm-1" style="width: 40px;">
            <div class="form-check">
              <label class="custom-checkbox">
                <input type="checkbox" id="records" :checked="isChecked" @change="onGlobalCheck" />
                <span class="select-check" style="left:15px"></span>
              </label>
            </div>
          </div>
          <div class="col-sm-3">
            <span class="info-header member_label cursor-pointer" @click="sortBy('name')">
            {{ $t('name')}}
              <span class="arrow" :class="nameArrowDirection === true ? 'down-arrow' : 'up-arrow'"></span>
            </span>
          </div>
          <div class="col-sm-4">
            <span class="info-header member_label cursor-pointer" @click="sortBy('member')">
            {{ $t('email')}}
              <span class="arrow" :class="memberArrowDirection === 1 ? 'down-arrow' : 'up-arrow'"></span>
            </span>
          </div>
          <div class="col-sm-4 p-0">
          <template>
          <div class="col-sm-6 info-header cursor-pointer" @click="sortBy('role')">
          {{ $t('role')}}
            <span class="arrow" :class="roleArrowDirection === true ? 'down-arrow' : 'up-arrow'"></span>
          </div>
          </template>
         </div>
        </div>
      </div>
      <div class="col-md-12 col-xs-12 container1 pl-0">
        <div class="section">
          <div class="col-md-12 col-sm-12 col-xs-12 scrollable-content">
            <div class="row member-box-wrapper" v-for="(member, index) in filterMembers" :key="index" :class="[(index%2 === 0) ? 'even-row' : 'odd-row', editRoleFlag && 'ptb-6']">
              <div class="col-sm-1 col-xs-1 pd-lt-1" style="width: 40px">
                <div class="col-md-12 col-xs-12 col-sm-12 xs-pd-rt-0 p-0">
                  <div class="form-check">
                    <label class="custom-checkbox">
                      <input type="checkbox" :class="`checkbox ${(loggedInUser.id === member.user_id) || editRoleFlag ? 'cursor-not-allowed' : ''}`" :id="`records-${index}`" v-model="checkedValue" :value="member.user_id" :disabled="(loggedInUser.id === member.user_id) || editRoleFlag" />
                      <span :class="`select-check ${(loggedInUser.id === member.user_id) || editRoleFlag ? 'cursor-not-allowed' : ''}`"></span>
                    </label>
                  </div>
                </div>
              </div>
              <div class="col-sm-3">
                <div class="member-text">
                  <div class="member-name member-name-ellipsis" :title="member.first_name+' '+member.last_name">{{member.first_name+' '+member.last_name}}</div>
                </div>
              </div>
              <div class="col-sm-4">
                <div class="member-text">
                  <div class="member-name email-ellipsis" :title="member.email">{{member.email}}</div>
                </div>
              </div>
              <div class="col-xs-4 col-sm-4">
                <div class="row">
    <div
      class="col-md-10 col-sm-10 col-xs-10 xs-mr-tp-10 xs-mr-bt-10 display-flex-mobile"
      v-bind:class="xshide?'hidden-xs':''"
    >
       <div class="roles-height">
        <span
          v-if="getRoleName(member.role_id) && !editRoleFlag"
          class="custom-dropdown color"
        >
         {{getRoleName(member.role_id)}}
        </span>
        <div v-if="editRoleFlag">
          <multiselect
            openDirection="below"
            :showLabels="false"
            :close-on-select="true"
            :allow-empty="false"
            class="product-class-ellipsis multiselect-single-dropdown"
            :searchable="false"
            :options="(listAllRoles.filter(role => role.role_id === 1 || role.role_id === 2 || role.role_id === 3)).map(role => role.role_id)"
            :custom-label="option => listAllRoles.find(x => x.role_id === option).role_name"
            v-model="member.role_id"
            placeholder="Select Role"
          >
          </multiselect>
        </div>
      </div>
    </div>
  </div>
              </div>
              <div class="edit-delete-dropdown">
                <template>
                  <div class="dropdown dropdown-export three-dots p-0 ">
                    <div data-toggle="dropdown" class="d-flex justify-content-end">
                      <span class="dropdown-toggle cursor-pointer" data-toggle="tooltip" data-placement="right" :class="(loggedInUser.id === member.user_id || editRoleFlag) ? 'disable-popup' : ''">
                        <img src="/static/images/icons/headlines_3_vertical_dots_menu.svg" />
                      </span>
                    </div>
                    <ul class="dropdown-menu tooltip-pointer dropdown-menu-ul" :class="(loggedInUser.id === member.user_id || editRoleFlag) ? 'disable-popup-class' : ''">
                      <li class="p-0 pl-0">
                        <a @click="openRbacPage(member)">
                          <!-- <img src="/static/images/icons/Headlines_Edit_icon.svg" class="tracker-images" /> -->
                          <span class="MRL-4 edit-text">{{ $t('edit') }}</span>
                        </a>
                      </li>
                      <li class="p-0 pl-0">
                        <a @click="openDeleteConfirmationPopup(member.user_id)">
                          <!-- <img src="/static/images/icons/Headlines_Delete_icon.svg" class="tracker-images" /> -->
                          <span class="MRL-4 delete-text">{{ $t('delete') }}</span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="editRoleFlag" class="footer col-xs-12 col-sm-12 d-flex-sm-end">
        <div class="xs-pd-lt-0">
          <button type="button" class="btn cancel_button" @click="cancelChanges">
            {{$t('cancel')}}</button>
          </div>
          <div class="xs-pd-lt-0 xs-pd-rt-0">
            <button type="button" class="btn save_changes_button" @click="saveRoleChanges">
              {{ $t('save')}}</button>
            </div>
      </div>
    </div>
    <template v-if="addTeamFlag">
      <add-team-member :roles="roles"
      :multi_factor_key="multi_factor_key"
      :member="selectedMember"
      :localDistributors="localDistributors"
      @cancelAddTeam="cancelAddTeam"
      @getTeamMembers="getTeamMembers"
      :account_type_id="loggedInUser.account_type_id">
      </add-team-member>
    </template>
    <template v-if="teamPermissionsFlag">
      <edit-team-member
      :roles="roles"
      :multi_factor_key="multi_factor_key"
      :member="selectedMember"
      @cancelAddTeam="cancelAddTeam"
      @getTeamMembers="getTeamMembers"
      :distributors="localDistributors"
      :account_type_id="loggedInUser.account_type_id">
      </edit-team-member>
    </template>
    <loader :loadingStatus="loaderStatus"></loader>
    <generic-popup
      :genericPopupId="genericPopupId"
      :genericHeader="'Team Limit'"
      :genericBody="'upgradeTeams'"
      :max_number="max_team_members"
      @emitUpgradeTeams="upgradeTeams"
      :isREP="loggedInUser.account_type_id === 2 || loggedInUser.account_type_id === 4"
    ></generic-popup>
    <warning-popup
      :warningPopupId="warningPopupId"
      :warningBody="warningBody"
      :confirmMessage="confirmMessage"
      @closeEdit="cancelChanges"
    ></warning-popup>
    <delete-popup
      :headerTitle="headerTitle"
      :deletewarnInfo="deleteWarningInfo"
      :teamMembersList="teamMembersName"
      :deleteMember="true"
      from="team"
      @dashboardPublishDelete="removeTeamMember()"
    >
    </delete-popup>
    <success-modal :successMessage="successMessage" :isTeamMember="true"></success-modal>
     <confirmation-popup :okButton="true" :title="addMemberTitle" :confirmationText="confirmationText" :confirmationMessage2="confirmationMessage"></confirmation-popup>
  </div>
</template>
<script>
import $ from 'jquery';
import * as moment from 'moment';
import Loader from '../../UIComponents/Loader.vue';
import SearchBox from '../../UIComponents/ULSearchBox.vue';
import SuccessModal from '../../Common/SuccessModal.vue';
import {
  removeTeamMember,
  getTeamMembers,
  saveRoleChanges,
} from '../../../apis/team';
import { isDefaultDashboard, setDefaultPreference } from '../../../apis/dashboardCustomization';
import EditTeamMember from './EditTeamMember.vue';
import { getRolesList, getUserData } from '../../../apis/profile';
import { getLocalDistributor } from '../../../apis/registrations';
import GenericPopup from '../../UIComponents/GenericPopup.vue';
import WarningPopup from '../../UIComponents/WarningPopup.vue';
import DeletePopup from '../../UIComponents/DeleteRegHeadlinePopup.vue';
import AddTeamMember from './AddTeamMember.vue';
import { getAddonDetails, upgradeAccountAddon } from '../../../apis/psm';
import { getListOfRoleNames } from '../../../apis/rbac';
import { getPurchaseDetails } from '../../../apis/marketPlace';
import ConfirmationPopup from '../../Common/ULConfirmationPopup.vue';

export default {
  components: {
    SuccessModal,
    DeletePopup,
    Loader,
    GenericPopup,
    WarningPopup,
    SearchBox,
    EditTeamMember,
    AddTeamMember,
    ConfirmationPopup
  },
  props: ['roleId', 'closeSubPage', 'resetTeams', 'downgradeCount', 'roleInfo'],
  data() {
    return {
      editRoleFlag: false,
      teamDowngradeCount: this.downgradeCount,
      successMessage: '',
      globalCheck: false,
      teamMember: '',
      team_member: '',
      order: -1,
      deleteWarningInfo: {
        loaderStatus: false,
        title: this.$i18n.locale === 'Portuguese' ? 'Você está prestes a excluir um membro. Uma vez excluído(s), você não poderá recuperar os dados.' : 'Your are about to delete a member. Once deleted, you will not be able to recover the data.',
      },
      isPreviouslySearched: false,
      rolesList: [], // Original roles based on account type
      listAllRoles: [], // All Roles irrespective of active status
      disableDistributorUpdate: true,
      errors: [],
      addTeamFlag: false,
      teamPermissionsFlag: false,
      loaderStatus: false,
      addMemberError: '',
      roles: [], // modified list during edit team member
      localDistributors: '',
      teamMembersList: '',
      filterMembers: [],
      placeValue: 'Select Role',
      team: {
        name: '',
        email: '',
        role: '',
        assigned_distributor_id: null,
      },
      updateRoleList: [],
      selectedRolesList: [],
      searchValue: '',
      checkedValue: [],
      infoActive: false,
      activeTab: 'role',
      xshide: [],
      max_team_members: 0,
      current_members: 0,
      genericPopupId: 'genericPopupTeam',
      recordAddonService: null,
      teamAddonService: null,
      selectedMember: '',
      servicesList: [],
      Permissions: '',
      multi_factor_key: false,
      loggedInUser: null,
      memberArrowDirection: 1,
      roleArrowDirection: true,
      nameArrowDirection: true,
      deletionId: '',
      warningPopupId: 'warning',
      warningBody: '',
      confirmMessage: '',
      headerTitle: '',
      purchaseDetails: '',
      addMemberTitle: '',
      confirmationText: '',
      confirmationMessage: ''
    };
  },
  computed: {
    teamMemberCount() {
      return this.filterMembers.filter((member) => !member.is_restricted).length;
    },
    isChecked() {
      if (this.checkedValue.length && this.checkedValue.length === this.filterMembers.filter((mem) => mem.user_id !== this.loggedInUser.id).length) {
        return true;
      }
      return false;
    },
    teamMembersName() {
      const arrName = [];
      if (this.checkedValue.length) {
        for (let i = 0; i < this.checkedValue.length; i += 1) {
          const member = this.teamMembersList.find(
            (memberObj) => memberObj.user_id === this.checkedValue[i],
          );
          if (member) {
            arrName.push(`${member.first_name} ${member.last_name}`);
          }
        }
      }
      return arrName;
    },
    selectAll: {
      get() {
        return this.allMemberIds.length
          ? this.checkedValue.length === this.allMemberIds.length
          : false;
      },
      set(value) {
        const selected = [];
        if (value) {
          this.allMemberIds.forEach((id) => {
            if (this.loggedInUser.id !== id) selected.push(id);
          });
        }
        this.checkedValue = selected;
      },
    },
    allMemberIds() {
      const allIds = [];
      this.filterMembers.forEach((curMember) => {
        allIds.push(parseInt(curMember.user_id, 10));
      });
      return allIds;
    },
  },
  watch: {
    // async addTeamFlag() {
    //   if (this.addTeamFlag) {
    //     await this.getRoles();
    //     await this.getTeamMembers();
    //   }
    // },
    closeSubPage(val) {
      if (val === 'close') {
        this.cancelAddTeam();
      }
    },
  },
  async created() {
    this.loggedInUser = localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData')) : await getUserData();
    await this.getRoles();
    await this.listOfAllRoles();
    await this.getDistributors();
    await this.getTeamMembers();
    await this.getPurchaseInfo();
    // await this.getMultiFactorAuthentication();
  },
  methods: {
    async getPurchaseInfo() {
      const response = await getPurchaseDetails();
      if (this.roleId === this.roleInfo['RA Admin']) this.purchaseDetails = response.find((item) => item.subscriptionId === 1);
      else this.purchaseDetails = response.find((item) => item.subscriptionId === 2);
    },
    onGlobalCheck(event) {
      if (event.target.checked) {
        this.checkedValue = this.filterMembers.filter((mem) => mem.user_id !== this.loggedInUser.id).map((mem) => mem.user_id);
      } else {
        this.checkedValue = [];
      }
    },
    async saveRoleChanges() {
      this.loaderStatus = true;
      const membersList = this.filterMembers.map(({ user_id, role_id }) => ({ user_id, role_id })); //eslint-disable-line
      const loggedInMember = membersList.filter((member) => member.user_id === this.loggedInUser.id);
      const response = await saveRoleChanges(membersList);
      if (response.status_code === 200) {
        this.loaderStatus = false;
        this.clearNotifcations();
        this.$notify({
          type: 'success',
          title: this.$i18n.locale === 'Portuguese' ? 'Sucesso' : 'Success',
          text: response.message,
          group: 'custom-notification',
        });
        this.editRoleFlag = false;
        if (loggedInMember[0].role_id !== 1) {
          console.log('sample', loggedInMember);
          socket.removeAllListeners(`alertSaveMultiRegistrationDetails_${localStorage.getItem('userId')}`);
          document.cookie = 'Authorization=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
          document.cookie = 'redirect_url=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
          localStorage.clear();
          sessionStorage.clear();
          this.$router.push('/login');
        }
      } else if (response.accountOwnerMessage === true) {
        this.loaderStatus = false;
        this.warningPopupId = 'warning';
        this.warningBody = response.message;
        this.confirmMessage = this.$i18n.locale === 'Portuguese' ? 'Por favor, defina um Proprietário da Conta' : 'Please make only one Account Owner';
        $(`#${this.warningPopupId}`).modal({
          backdrop: 'static',
          keyboard: false,
        });
      } else {
        this.clearNotifcations();
        this.$notify({
          type: 'error',
          title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
          text: response.message,
          group: 'custom-notification',
        });
      }
    },
    async cancelChanges() {
      this.editRoleFlag = false;
      await this.getTeamMembers();
    },
    getRoleName(id) {
      const role = this.listAllRoles.find((r) => r.role_id === id);
      return role ? role.role_name : '';
    },
    editRole() {
      this.editRoleFlag = !this.editRoleFlag;
    },
    todayDate() {
      return moment()
        .utc()
        .format('YYYY-MM-DD HH:mm:ss');
    },
    async upgradeAccount() {
      const addonDetails = await getAddonDetails(JSON.parse(localStorage.getItem('userData')).account_id);
      const teamIndex = addonDetails.findIndex(
        (addon) => addon.units === 'USERS',
      );
      if (teamIndex >= 0) {
        this.teamMember = addonDetails[teamIndex];
        this.team_member = { label: `${this.teamMember.total_limit} Members`, value: this.teamMember.total_limit };
      }
      this.loaderStatus = true;
      let teamValidUntil;
      if (this.teamMember && this.teamMember.valid_until > this.todayDate() && this.teamMember.total_limit > this.teamMember.default_limit) {
        teamValidUntil = this.teamMember.valid_until;
      } else {
        teamValidUntil = moment
          .utc()
          .add('years', 1)
          .subtract(1, 'days')
          .format('YYYY-MM-DD HH:mm:ss');
      }
      const formData = {
        account_id: JSON.parse(localStorage.getItem('userData')).account_id,
        add_on: [
          {
            account: true,
            active: true,
            id: 1,
            price: 0,
            valid_from: moment(this.teamMember.valid_from).format(
              'YYYY-MM-DDTHH:mm:ss.SSS[Z]',
            ),
            valid_until: moment(teamValidUntil).format(
              'YYYY-MM-DDTHH:mm:ss.SSS[Z]',
            ),
            volume: this.downgradeCount,
          },
        ],
        operation: 12,
        payment_mode: 4,
        total_amount: 0,
      };
      const response = await upgradeAccountAddon(formData);
      this.loaderStatus = false;
      if (response.message === 'success' && response.status_code === 200) {
        this.teamMember.total_limit = this.team_member.value;
        this.successMessage = this.$i18n.locale === 'Portuguese' ? 'A contagem de membros da equipe foi atualizada com sucesso' : 'Team member count has been updated successfully';
        this.clearNotifcations();
        this.$notify({
          type: 'success',
          title: this.$i18n.locale === 'Portuguese' ? 'Sucesso' : 'Success',
          text: this.$i18n.locale === 'Portuguese' ? 'A contagem de membros da equipe foi atualizada com sucesso' : 'Team member count has been updated successfully',
          group: 'custom-notification',
        });
        this.teamDowngradeCount = 0;
      } else {
        this.clearNotifcations();
        this.$notify({
          type: 'error',
          title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
          text: response.data,
          group: 'custom-notification',
        });
        this.teamDowngradeCount = 0;
      }
    },
    headerClicked(a1, b1, name) {
      let a;
      let b;
      if (name === 'member') {
        a = a1.first_name;
        b = b1.first_name;
      } else if (name === 'role') {
        a = a1.role_id;
        b = b1.role_id;
      } else if (name === 'name') {
        a = a1.email;
        b = b1.email;
      }
      if (a === b) return 0 * this.order;
      if (a > b) return 1 * this.order;
      return -1 * this.order;
    },
    sortBy(name) {
      const properData = [];
      const data = this.filterMembers;
      for (let i = 0; i < data.length; i += 1) {
        if (data[i].first_name !== null && data[i].first_name !== '') {
          properData.push(data[i]);
        }
      }
      properData.sort((a1, b1) => this.headerClicked(a1, b1, name));
      if (name === 'member') {
        this.memberArrowDirection = -(this.memberArrowDirection);
      } else if (name === 'role') {
        this.roleArrowDirection = !this.roleArrowDirection;
      } else {
        this.nameArrowDirection = !this.nameArrowDirection;
      }
      this.order = -(this.order);
      this.filterMembers = properData;
    },
    deselectAllCheckedValues() {
      this.checkedValue = [];
    },

    clearNotifcations() {
      this.$notify({
        clear: true,
        group: 'custom-notification',
      });
    },

    openDeleteConfirmationPopup(id) {
      if (id) this.deletionId = id;
      this.headerTitle = this.$i18n.locale === 'Portuguese' ? 'Excluir membro(s)' : 'Delete Member(s)';
      $('#modal_delete').modal({
        backdrop: 'static',
        keyboard: false,
      });
    },

    // async updateMultiFactorAuthentication() {
    //   this.loaderStatus = true;
    //   const response = await updateMultiFactorAuthentication({ mfa: this.multi_factor_key });
    //   this.loaderStatus = false;
    //   if (response && response.status) {
    //     this.clearNotifcations();
    //     this.$notify({
    //       type: 'success',
    //       title: 'Success',
    //       text: 'Updated Two Factor Autentication successfully',
    //       group: 'custom-notification',
    //     });
    //   } else {
    //     this.multi_factor_key = !this.multi_factor_key;
    //     this.clearNotifcations();
    //     this.$notify({
    //       type: 'error',
    //       title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
    //       text: 'Unable to update Two Factor Authentication',
    //       group: 'custom-notification',
    //     });
    //   }
    // },
    // async getMultiFactorAuthentication() {
    //   this.loaderStatus = true;
    //   const response = await getMultiFactorAuthentication();
    //   this.loaderStatus = false;
    //   if (response) {
    //     this.multi_factor_key = response.mfa;
    //   }
    // },
    cancelAddTeam() {
      this.addTeamFlag = false;
      this.teamPermissionsFlag = false;
      this.$emit('emitBreadCrumb', false);
    },
    // open role based permission page
    openRbacPage(member) {
      this.teamDowngradeCount = 0;
      this.selectedMember = member;
      if (this.roles.findIndex((role) => role.id === member.role_id) === -1) { // Validate selected role id found in the roles
        const selectedRoleDetails = this.listAllRoles.find((role) => role.role_id === member.role_id);
        this.roles.push({ id: selectedRoleDetails.role_id, name: selectedRoleDetails.role_name });
      }
      this.teamPermissionsFlag = true;
      this.$emit('emitBreadCrumb', 'Member');
    },
    upgradeTeams() {
      $('#UpgradeModal').modal({
        backdrop: 'static',
        keyboard: false,
      });
    },
    upgradeRegPathwayAddOn() {
      $('#UpgradeModal').modal({
        backdrop: 'static',
        keyboard: false,
      });
    },

    filterTeamsList() {
      if (this.searchValue) {
        this.filterTeamMembers();
        this.isPreviouslySearched = true;
      } else if (this.isPreviouslySearched) {
        this.filterTeamMembers();
        this.isPreviouslySearched = false;
      }
    },

    dropDownEvent(id) {
      this.$set(this.xshide, id, !this.xshide[id]);
    },
    validateRemoveAuthority(assignedRoleId) {
      if (this.roleId === 9) {
        if (
          assignedRoleId !== 1
          && assignedRoleId !== 5
          && assignedRoleId !== 6
        ) {
          return true;
        }
      } else {
        return true;
      }
      return false;
    },
    updatedRole(respObj) {
      this.selectedRolesList[respObj.member.id].id = respObj.selectedId;
      this.updateRole(respObj.member);
    },
    emitedDistributor(membobj) {
      this.updateRoleDistributor(membobj.id, membobj.dist_id);
      this.checkChanges();
    },
    async filterTeamMembers() {
      const searchStr = this.searchValue.trim();
      this.filterMembers = [];
      if (!searchStr.length) {
        this.filterMembers = this.teamMembersList;
        return;
      }
      this.filterMembers = this.teamMembersList.filter((each) => this.searchString(searchStr, each));
      this.validateCheckedValue();
    },
    validateCheckedValue() {
      const check = [];
      for (let i = 0; i <= this.checkedValue.length; i += 1) {
        if (this.validateFilterMemberVal(this.checkedValue[i])) {
          check.push(this.checkedValue[i]);
        }
      }
      this.checkedValue = check;
    },
    validateFilterMemberVal(id) {
      let valid = false;
      for (let member = 0; member < this.filterMembers.length; member += 1) {
        if (this.filterMembers[member].user_id === id) {
          valid = true;
          break;
        }
      }
      return valid;
    },
    searchString(searchValue, member) {
      if ((member.first_name.toLowerCase()).indexOf(searchValue.toLowerCase()) !== -1) {
        return true;
      }
      if ((member.email.toLowerCase()).indexOf(searchValue.toLowerCase()) !== -1) {
        return true;
      }
      if ((member.last_name.toLowerCase()).indexOf(searchValue.toLowerCase()) !== -1) {
        return true;
      }
      const role = this.returnRoleName(member.assigned_role_id);
      if (role.search(new RegExp(searchValue, 'i')) !== -1) {
        return true;
      }

      if (this.validateDistributer(member, searchValue)) {
        return true;
      }
      return false;
    },
    returnRoleName(roleId) {
      const role = this.roles.find((each) => each.id === roleId);
      return role ? role.name : '';
    },
    validateDistributer(member, searchValue) {
      if (member.assigned_distributor_id) {
        const distributor = this.returnDistributerName(
          member.assigned_distributor_id,
        );
        if (distributor.search(new RegExp(searchValue, 'i')) !== -1) {
          return true;
        }
      }
      return false;
    },
    returnDistributerName(distributorId) {
      const distributor = this.localDistributors.find(
        (each) => each.id === distributorId,
      );
      return distributor ? distributor.distributor_name : '';
    },
    updateRole(member) {
      const { id } = member;
      const role = this.selectedRolesList[id].id;
      const distributor = member.assigned_distributor_id;
      let flag = false;
      for (let i = 0; i < this.updateRoleList.length; i += 1) {
        if (this.updateRoleList[i].user_id === id) {
          this.updateRoleList[i].assigned_role_id = role;
          if (role === 6) this.updateRoleList[i].assigned_distributor_id = distributor;
          flag = true;
          break;
        }
      }
      if (!flag) {
        const data = {
          user_id: id,
          assigned_role_id: role,
        };
        if (role && role === 6) data.assigned_distributor_id = distributor;
        this.updateRoleList.push(data);
      }
      this.checkChanges();
    },
    updateRoleDistributor(id, distributor) {
      let flag = false;
      for (let i = 0; i < this.updateRoleList.length; i += 1) {
        if (this.updateRoleList[i].user_id === id) {
          this.updateRoleList[i].assigned_distributor_id = distributor;
          flag = true;
          break;
        }
      }
      if (!flag) {
        this.updateRoleList.push({
          user_id: id,
          assigned_role_id: 6,
          assigned_distributor_id: distributor,
        });
      }
    },
    getInitials(firstname, lastname) {
      return `${firstname ? firstname.charAt(0).toUpperCase() : ''}${lastname ? lastname.charAt(0).toUpperCase() : ''}`;
    },
    async validateTeamUpgrade() {
      this.loaderStatus = true;
      const addonAccountDetails = await getAddonDetails(
        JSON.parse(localStorage.getItem('userData')).account_id,
      );
      this.recordAddonService = addonAccountDetails.find(
        (each) => each.units === 'RECORDS',
      );
      this.teamAddonService = addonAccountDetails.find(
        (each) => each.units === 'USERS',
      );
      this.loaderStatus = false;
      if (this.teamAddonService) {
        if (
          this.teamAddonService.total_limit
            >= this.teamAddonService.default_limit
          && this.teamAddonService.is_active
          && moment().utc().format('YYYY-MM-DD HH:mm:ss') < this.teamAddonService.valid_until
          && moment().utc().format('YYYY-MM-DD HH:mm:ss') >= this.teamAddonService.valid_from
        ) {
          this.max_team_members = this.teamAddonService.total_limit;
        } else if (
          this.teamAddonService.total_limit
            >= this.teamAddonService.default_limit
          && this.teamAddonService.is_active
          && moment().utc().format('YYYY-MM-DD HH:mm:ss')
            > this.teamAddonService.valid_until
          && moment().utc().format('YYYY-MM-DD HH:mm:ss')
            >= this.teamAddonService.valid_from
        ) {
          this.max_team_members = this.teamAddonService.default_limit;
        }
        this.current_members = this.teamAddonService.current_utilization;
      }
    },
    async addTeamMemberSection() {
      if ((!this.purchaseDetails && (this.roleId === this.roleInfo['Super Admin'] || this.roleId === this.roleInfo['RA Admin'])) || (this.purchaseDetails && this.purchaseDetails.currentUtilized === this.purchaseDetails.totalLimit && (this.roleId === this.roleInfo['Super Admin'] || this.roleId === this.roleInfo['RA Admin']))) {
        this.addMemberTitle = this.$i18n.locale === 'Portuguese' ? 'Limite de equipe' : 'Team Limit';
        this.confirmationText = this.$i18n.locale === 'Portuguese' ? 'Seu limite foi usado.' : 'Your limit has been utilized.';
        this.confirmationMessage = this.$i18n.locale === 'Portuguese' ? 'Para atualizar sua conta, entre em contato com CDMHelp@ul.com.' : 'To update your account please contact CDMHelp@ul.com.';
        $('#deleteRecord').modal('show');
        return;
      }
      if ((!this.purchaseDetails && this.roleId === 1) || (this.purchaseDetails && this.purchaseDetails.purchasedLimit <= 0 && this.roleId === 1)) {
        this.addMemberTitle = this.$i18n.locale === 'Portuguese' ? 'Adicionar Membro' : 'Add Member';
        this.confirmationText = this.$i18n.locale === 'Portuguese' ? 'Você está tentando adicionar um novo membro à equipe antes de adquirir os Serviços PRO.' : 'You are trying to add a new member in the team before purchasing the PRO Services.';
        this.confirmationMessage = this.$i18n.locale === 'Portuguese' ? 'Assine os serviços profissionais para adicionar mais um membro da equipe' : 'Please subscribe to pro services to add additional team member';
        $('#deleteRecord').modal('show');
        return;
      }
      if (this.purchaseDetails && this.purchaseDetails.currentUtilized === this.purchaseDetails.totalLimit && this.purchaseDetails.totalLimit < this.purchaseDetails.purchasedLimit && this.roleId !== this.roleInfo['Super Admin']) {
        this.addMemberTitle = this.$i18n.locale === 'Portuguese' ? 'Limite de equipe' : 'Team Limit';
        this.confirmationText = this.$i18n.locale === 'Portuguese' ? `Sua conta está atualmente limitada a um número máximo de ${this.purchaseDetails.totalLimit} membros` : `Your account is currently limited to a maximum number of ${this.purchaseDetails.totalLimit} members.`;
        this.confirmationMessage = this.$i18n.locale === 'Portuguese' ? 'Atualize sua conta na guia Serviços.' : 'Please update your account from Services tab.';
        $('#deleteRecord').modal('show');
        return;
      }
      if (this.purchaseDetails && this.purchaseDetails.currentUtilized === this.purchaseDetails.purchasedLimit && this.roleId !== this.roleInfo['Super Admin']) {
        this.addMemberTitle = this.$i18n.locale === 'Portuguese' ? 'Limite de equipe' : 'Team Limit';
        this.confirmationText = this.$i18n.locale === 'Portuguese' ? `Sua conta está atualmente limitada a um número máximo de ${this.purchaseDetails.purchasedLimit} membros` : `Your account is currently limited to a maximum number of ${this.purchaseDetails.purchasedLimit} members.`;
        this.confirmationMessage = this.$i18n.locale === 'Portuguese' ? 'Seu limite de compra foi utilizado. Atualize o serviço profissional antes de adicionar um novo membro da equipe.' : 'Your purchase limit has been utilized. Please upgrade pro service before adding new team member.';
        $('#deleteRecord').modal('show');
        return;
      }
      this.teamDowngradeCount = 0;
      await this.validateTeamUpgrade();
      this.roles = [...new Set(this.rolesList)]; // To overRide actual roles at the time of creation
      if (this.current_members < this.max_team_members) {
        this.checkedValue = [];
        this.updateRoleList = [];
        this.team = {
          first_name: '',
          last_name: '',
          email: '',
          role: '',
          assigned_distributor_id: null,
          user_type_id: 1,
        };
        this.addMemberError = '';
        this.searchValue = '';
        this.filterTeamMembers();
        await this.getPurchaseInfo();
        this.addTeamFlag = true;
        this.$emit('emitBreadCrumb', 'New Member');
      }
    },
    async listOfAllRoles() {
      this.loaderStatus = true;
      this.listAllRoles = await getListOfRoleNames();
      this.loaderStatus = false;
    },
    async getRoles() {
      this.loaderStatus = true;
      this.rolesList = (await getRolesList()).filter((role) => role.id !== 1);
      this.roles = [...new Set(this.rolesList)];
      this.loaderStatus = false;
    },
    async getDistributors() {
      this.loaderStatus = true;
      this.localDistributors = await getLocalDistributor();
      this.loaderStatus = false;
    },
    async getTeamMembers() {
      this.loaderStatus = true;
      const userData = localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData')) : await getUserData();
      this.teamMembersList = await getTeamMembers((userData.account_type_id === 2 || userData.account_type_id === 4) ? 1 : 0);
      if (this.teamMembersList.length) {
        const index = this.teamMembersList.findIndex((member) => member.user_id === this.loggedInUser.id);
        if (index > -1) {
          this.teamMembersList.unshift(this.teamMembersList[index]);
          this.teamMembersList.splice(index + 1, 1);
        }
      }
      this.filterMembers = this.teamMembersList;
      this.selectedRolesList = [];
      this.xshide = [];
      this.teamMembersList.forEach((curMember) => {
        this.selectedRolesList[curMember.id] = {
          id: curMember.role_id,
          name: this.returnRoleName(curMember.role_id),
        };
        this.xshide[curMember.id] = true;
      });
      await this.getPurchaseInfo();
      this.loaderStatus = false;
    },
    async removeTeamMember() {
      this.deleteWarningInfo = {
        ...this.deleteWarningInfo,
        loaderStatus: true,
      };
      let data = {};
      if (this.deletionId) {
        data = {
          userIds: [this.deletionId],
        };
        this.deletionId = '';
      } else {
        data = {
          userIds: this.checkedValue,
        };
      }
      const resp = await removeTeamMember(data);
      this.deleteWarningInfo = {
        ...this.deleteWarningInfo,
        loaderStatus: false,
      };
      $('#modal_delete').modal('hide');
      this.loaderStatus = false;
      if (resp.status) {
        this.loaderStatus = true;
        this.checkedValue.forEach(async (id) => {
          const isDefault = await isDefaultDashboard(JSON.parse(localStorage.getItem('userData')).account_id, id);
          const defaultData = {
            account_id: JSON.parse(localStorage.getItem('userData')).account_id,
            user_id: id,
            dashboard_notification_type_id: 3,
          };
          if (!isDefault) {
            await setDefaultPreference(defaultData);
          }
        });
        this.loaderStatus = false;
        this.clearNotifcations();
        this.$notify({
          type: 'success',
          title: this.$i18n.locale === 'Portuguese' ? 'Sucesso' : 'Success',
          text: this.$i18n.locale === 'Portuguese' ? 'Membro removido com sucesso!' : 'Member removed successfully!',
          group: 'custom-notification',
        });
        this.checkedValue = [];
        await this.getTeamMembers();
        await this.filterTeamMembers();
        if (this.teamDowngradeCount !== 0 && this.teamDowngradeCount >= this.teamMemberCount) {
          this.upgradeAccount();
        }
      } else {
        this.clearNotifcations();
        this.$notify({
          type: 'error',
          title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
          text: this.$i18n.locale === 'Portuguese' ? 'Não foi possível remover o membro' : "Member couldn't be removed",
          group: 'custom-notification',
        });
      }
    },
    checkChanges() {
      let counter = 0;
      this.updateRoleList.forEach((data) => {
        if (
          data.assigned_role_id === 6
          && data.assigned_distributor_id === null
        ) counter += 1;
      });
      this.disableDistributorUpdate = true;
      if (counter === 0 && this.updateRoleList.length > 0) {
        this.disableDistributorUpdate = false;
      }
    },
  },
};
</script>
<style>
.edit-delete-tooltip.el-popper[x-placement^=top] .popper__arrow {
    bottom: 0px;
    left: 0;
    margin-right: 0px;
    /* border-top-color: #164ccb; */
    border-bottom-width: 0;
    /* box-shadow: 2px 4px 10px rgba(0, 0, 0, 0.25); */
}
.edit-delete-tooltip.el-popper[x-placement^=top] .popper__arrow::after {
    bottom: -18px;
    margin-left: -20px;
    border-top-color: #fff;
    border-left: 11px solid transparent;
    border-right: 11px solid transparent;
}
.edit-delete-tooltip.el-popper[x-placement^=bottom] .popper__arrow {
    top: -6px;
    left: 0;
    margin-right: 0px;
    border-top-width: 0;
    /* border-bottom-color: #EBEEF5; */
}
.edit-delete-tooltip.el-popper[x-placement^=bottom] .popper__arrow::after {
    top: -10px;
    margin-left: -20px;
    border-top-width: 0;
    border-bottom-color: #fff;
    border-left: 11px solid transparent;
    border-right: 11px solid transparent;
}
.edit-delete-tooltip.el-popper .popper__arrow{
  border-width: 0px;
}
.edit-delete-tooltip.el-popper .popper__arrow::after {
    content: " ";
    border-width: 18px;
}
.roles-info-tooltip.el-popper[x-placement^=bottom]{
  margin-top: 32px !important;
}
/* #sample{
  margin-right: 30px;
} */
.roles-info-tooltip .el-tabs__header{
  margin: 0px !important;
}
.roles-info-tooltip.el-popover{
  /* margin-left: 25px; */
  padding-top: 0px;
  padding-bottom: 4px;
  padding-left: 12px;
  padding-right: 13px;
  left: 912px !important;
  width: 330px !important;
  background: #FDFDFD;
  border-radius: 10px;
}
.roles-info-tooltip .info-tabs .el-tabs__nav-wrap:after{
  margin-bottom: 4px;
}
.roles-info-tooltip.el-popper[x-placement^=bottom] .popper__arrow::after {
    top: -19px !important;
    margin-left: -28px !important;
    border-top-width: 0 !important;
    border-left: 11px solid transparent;
    border-right: 11px solid transparent;
    border-bottom-color: #fff !important;
}
.roles-info-tooltip.el-popper .popper__arrow {
    border-width: 0px !important;
}
.roles-info-tooltip.el-popper .popper__arrow::after {
    content: " ";
    border-width: 20px;
}
.roles-info-tooltip.el-popper[x-placement^=bottom] .popper__arrow {
    top: 0px !important;
    /* left: 0 !important; */
    margin-right: 0px !important;
    border-top-width: 0 !important;
    /* border-bottom-color: #EBEEF5; */
}
</style>

<style scoped>
.multiselect-single-dropdown >>> .multiselect__option:hover {
  border:1px solid #0A99ff !important;
}
.multiselect-single-dropdown.multiselect--disabled >>> .multiselect__select{
  padding-top: 0px !important;
}
.product-class-ellipsis.multiselect-single-dropdown
>>> .multiselect__single,
.accredited-by-ellipsis.multiselect-single-dropdown
>>> .multiselect__single{
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 450px;
  margin-bottom: 0px;
}
.multiselect-single-dropdown.multiselect--active::before{
  content: none;
}
.multiselect--active
  >>> .multiselect__tags{
    border-radius: 3px !important;
    border-bottom: none;
    border-bottom-left-radius: 0px !important;
    border-bottom-right-radius: 0px !important;
    border-top: 1px solid #CCCCCC;
    border-right: 1px solid #CCCCCC;
    border-left: 1px solid #CCCCCC;
  }
  .multiselect--active >>> .multiselect__option--highlight:after{
    content: none !important;
  }
  .multiselect--active >>> .multiselect__option--selected.multiselect__option--highlight:after{
    content: none !important;
  }
  .multiselect--active >>> .multiselect__option--selected:after{
    content: none !important;
  }
.multiselect{
  min-height: 34px;
}
  .multiselect-single-dropdown
  >>> .multiselect__tags{
    border-radius: 3px;
    height: 34px;
    padding: 3px 40px 6px 11px;
    border: 1px solid #4D4D4D !important;
  }
  .multiselect-single-dropdown
  >>> .multiselect__select{
    padding-top: 7px !important;
  }
  .multiselect-single-dropdown.multiselect--disabled >>> .multiselect__select{
    padding-top:8px !important;
  }
  .multiselect-single-dropdown.multiselect--disabled {
        background: #ededed;
        pointer-events: none;
        opacity: 0.4;
  }
  .multiselect-single-dropdown
  >>> .multiselect__select:before{
    position: relative;
    right: 0;
    color: #4D4D4D;
    margin-top: 4px;
    border-color:  #4D4D4D transparent transparent;
    border-style: solid;
    border-width: 7px 7px 0;
    content: "";
    transform: rotate(0) !important;
    padding: 0px !important;
  }
  .multiselect-single-dropdown
  >>> .multiselect__option:hover{
    background: #FFFFFF !important;
  }
  .multiselect--active
  >>> .multiselect__select{
    padding-bottom: 6px !important;
    padding-top: 4px !important;
  }
  .multiselect-single-dropdown
  >>> .multiselect__content-wrapper .multiselect__option--highlight.multiselect__option--selected{
    border: 1px solid #0A99FF;
  }
  .multiselect-single-dropdown.multiselect--active
  >>> .multiselect__option--selected{
    background: #FFFFFF !important;
    border: 1px solid #0A99FF;

  }
  .multiselect-single-dropdown
    >>> .multiselect__option--selected:before {
    content: none;
  }
  .multiselect--active
  >>> .multiselect__tags::after{
    content: '';
    display: flex;
    align-items: center;
    position: absolute;
    bottom: 0;
    left: 11px;
    right: -13px;
    border: 0.5px solid #CCCCCC !important;
    opacity:0.5;
    width: 95%;

  }
  .multiselect-single-dropdown
  >>> .multiselect__single {
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #4D4D4D;
    overflow: visible;
    padding-left:0px;
  }
  .multiselect-single-dropdown
  >>> .multiselect__placeholder {
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #999999;
    overflow: visible;
  }
  .multiselect-single-dropdown >>> .multiselect__input::placeholder{
     color: #4D4D4D !important;
     padding-left:4px !important
  }
.multiselect--active
  >>>  .multiselect__single,
  .multiselect--active
  >>> .multiselect__placeholder{
    padding: 1px 40px 4px 0px;
  }
 .multiselect--active
  >>> .multiselect__input{
    padding-left: 1px !important;
    padding-top: 4px !important;
    padding-bottom: 4px;
    margin-bottom: 0px;
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #4D4D4D;
  }
  .multiselect-single-dropdown >>> .multiselect__input{
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #4D4D4D;
    padding-top: 1px !important;
  }
  .multiselect-single-dropdown
  >>> .multiselect__content{
    margin-top: 5px;
  }
  .multiselect-single-dropdown
  >>> .multiselect__content .multiselect__element span{
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #4D4D4D;
  }
  .multiselect-single-dropdown
  >>> .multiselect__content .multiselect__element .multiselect__option{
    padding-left: 16px;
    padding-top:11px;
    padding-bottom: 10px;
    padding-right: 0px;
  }
  @media screen and (max-width: 1025px) {
    .multiselect--active
  >>> .multiselect__tags::before{
    left: 10px;
    width:94%
  }
}
.multiselect-single-dropdown.multiselect--active
>>> .multiselect__content-wrapper{
    border:1px solid #CCCCCC;
    border-top: none;
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
    margin-top: 0px;
    max-height: 229px !important;
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;
  }
  .multiselect-single-dropdown
  >>> .multiselect__content-wrapper{
    -webkit-box-shadow:none;
     box-shadow: none;
  }
.pl-0 {
  padding-left: 0 !important;
  padding-bottom: 5px !important;
}
.dropdown-export .export-menu li .MRL-4 {
  margin-left: 4px;
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 19px;
  color: #34117e;
}
.dropdown-export .export-menu li .MRR-4 {
  margin-right: 4px;
}
.dropdown-export .export-menu img,
.viewRegistration img {
  width: 18px;
  vertical-align: sub;
  height: 18px;
}
.dropdown-export .export-menu img.unarchive {
  height: 20px;
}
.dropdown-export .export-menu span {
  font-size: 14px;
}
.custom-three-dots {
  padding-right: 10px;
  padding-top: 5px;
}
.edit-text {
  font-size: 16px;
  color: #4d4d4d;
}
.delete-text {
  font-size: 16px;
  color: #e12d33;
}
.tooltip-pointer li:first-child {
  padding-bottom: 6px;
}
.tooltip-pointer:before {
  position: absolute;
  top: -10px;
  height: 0;
  width: 0;
  /* left: 84%; */
  right: 4%;
  border-left: 9px solid transparent;
  border-right: 9px solid transparent;
  border-bottom: 12px solid #ffffff;
  content: '';
}
.dropdown-menu-ul {
  /* left: -150px !important; */
  right: -4px !important;
  left: unset;
}
.dropdown-menu-ul::after {
  right: 1em !important;
}
.dropdown-menu {
  /* left: -15px; */
  min-width: 193px;
  height: 70px;
  box-shadow: 2px 4px 10px rgba(0, 0, 0, 0.25);
  border-radius: 5px;
  border: none;
  top: 34px !important;
  padding: 0px 0px 0px 20px;
  background: #ffffff;
}
.dropdown-menu > li > a {
  padding: 0px;
  display: flex;
  color: rgb(52, 17, 126);
}
.dropdown-menu > li > a:focus,
.dropdown-menu > li > a:hover {
  color: rgb(52, 17, 126);
}
.dropdown-menu .divider {
  margin: 0px;
}
.edit-delete-dropdown {
  display: flex;
  justify-content: flex-end;
  padding-right: 15px;
}
.even-row {
  background: #FAFAFA;
}
.pr-17 {
  padding-right: 17px;
}
.odd-row {
  background: #F5F5F5;
}
.role-definition-title{
  font-size: 16px;
}
/* .member-box-wrapper:first-child {
  padding-top: 18px;
} */
.pl-8 {
  padding-left: 8px !important;
}
.disable-popup {
  cursor: not-allowed;
  opacity: 0.5;
}
.disable-popup-class {
  display: none !important;
}
.color-on-hover:hover {
  opacity: 0.5;
}
.info-icon{
  margin-right: 10px;
  margin-top: 3px;
}
.arrow.asc {
  float: right;
  margin-top: 6px;
}
.arrow.dsc {
  float: right;
  margin-top: 6px;
}
.el-dropdown-menu.el-popper{
  /* padding-left: 17px; */
  /* padding-top: 10px;
  padding-bottom: 18px; */
  background: #FDFDFD;
  box-shadow: 2px 3px 12px rgba(0, 0, 0, 0.27);
  cursor: default;
  padding: 10px 13px 18px 12px;
}
.el-dropdown-menu__item{
  padding-left: 0px;
  padding-right: 0px;
  line-height: 25px;
  margin-top: 8px;
}
.edit-delete-section{
  display: flex;
  align-items: center;
  padding-left: 12px;
}
.role-definition-section {
  cursor: default !important;
}
.el-popper .popper__arrow {
    border-width: 20px !important;
    -webkit-filter: drop-shadow(0 2px 12px rgba(0, 0, 0, .03));
    filter: drop-shadow(0 2px 12px rgba(0, 0, 0, .03));
}
.el-popper .popper__arrow::after{
  border-right: 14px solid #fff;
    border-top-color: #c41414;
    border-bottom-width: -1px;
    border-width: 20px !important;
    bottom: -38px;
    left: 50%;
    margin-left: -10px;
}
.role-definition {
  border-bottom: inset;
  border-bottom-width: 2px;
}
.role-definition-color {
  color: #01518a;
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 19px;
  padding-top: 4px;
}
.fw-300 {
  font-weight: 300;
}
.el-dropdown-menu {
  min-width: 180px;
  min-height: 90px;
  box-shadow: 2px 4px 10px rgba(0, 0, 0, 0.25);
}
.info-tabs >>> .el-tabs__active-bar {
  background-color: transparent;
}
.info-tabs >>> .el-tabs__nav-wrap:after {
  background-color:#828282;
  height: 1px;
  opacity: 0.3;
}
.info-tabs >>> .el-tabs__item {
  color: #01518a !important;
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  /* line-height: 22px; */
}
.el-dropdown-menu__item:focus, .el-dropdown-menu__item:not(.is-disabled):hover {
  background-color: transparent !important;
}
/* .arrow {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 4px solid #B4B4B4;
} */
.arrow {
  opacity: 1;
}
.down-arrow {
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 6px solid #999999;
}
.up-arrow {
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 6px solid #999999;
}
.edit {
  /* margin-top: 8px; */
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #01518a;
}
.delete {
  color: #B00505;
  /* margin-top: 8px; */
  /* margin-bottom: 8px; */
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
}
/* .del-btn{
  margin-bottom: 10px;
} */
.line-1 hr {
  margin: 16px 0 22px 0;
  border-top: 0.5px solid #828282;
  opacity: 0.4;
}
.line-2 hr {
  margin: 4px 0 0 0;
  opacity: 0.8;
}
.add_member_and_tooltip {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.add_team_member, .add_team_member:hover {
  background: #01518a;
  color: #FFFFFF !important;
  /* margin-right: 8px; */
  font-weight: 600;
  font-size: 16px;
  padding: 6px 16px;
}
.pl-34 {
  padding: 0 34px;
}
.ml-48 {
  margin-left: 48px;
}
.team_member_count {
  padding: 4px 33px 10px 34px;
}
.team_member_found {
  font-size: 18px;
  font-weight: 600;
  color: #333333;
}
.btn-disabled, .btn-disabled:hover {
  border: none;
  background: #ffffff;
}
.deselect-buttons {
  font-size: 14px;
  font-weight: 400;
}
.deselect-button-color, .deselect-button-color:hover {
  color: #01518a;
}
.delete-button-color, .delete-button-color:hover{
  color: #B00505;
}
.delete-button-color {
  padding-left: 15px;
  color: #B00505;
  display: flex;
  align-items: center;
}
.pl-12 {
  padding: 0 0 0 12px;
}
.pl-5{
  padding: 0 0 0 5px;
}
.pl-9{
  padding: 0 0 0 6px;
}
.opacity-7{
  opacity: 0.7;
}
.relative-pos{
    position: relative;
}
.notification-red{
  position: absolute;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  right: 0;
  bottom: -3px;
}
.notification-red-on-image{
  position: absolute;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  right: 0;
  top: 20px;
  left: 16px;
  bottom: 0;
}
.container1 {
  /* position: absolute; */
  left: 0px;
  right: 0px;
  display: flex;
  flex-direction: column;
  /* max-height: calc(70vh - 250px); */
  /* padding-left: 256px; */
  padding-right: 0px;
  padding-bottom: 100px;
  /* margin-top: 269px; */
}
.section {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  padding-right: 2px;
  margin-bottom: 13%;
}
.scrollable-content {
  flex-grow: 1;
  /* overflow: auto;
  overflow-x: hidden; */
  min-height: 0;
  padding: 0 34px;
}
.scrollable-content::-webkit-scrollbar {
  width: 6px;
}
.scrollable-content::-webkit-scrollbar-thumb {
  background: #D9D9D9;
  border-top-left-radius: 18px;
  border-bottom-left-radius: 18px;
}
/* .scrollable-content::-webkit-scrollbar-track-piece:end {
  margin-bottom: 80px;
} */
.search-reset-label {
  right: 30px;
  top: 6px;
}
.custom-profile-pic-title {
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  background: #f2f2f2;
  color: #00518a;
}
.xs-collapse-arrow {
  height: 14px;
  width: 14px;
  background-image: url(/static/images/icons/chevron_down_grey.svg);
  background-repeat: no-repeat;
}
.xs-collapse-arrow.active {
  background-image: url(/static/images/icons/chevron_up_grey.svg);
}
.arrow-disp {
  display: none;
}
.member-name {
  font-weight: 400;
  font-size: 16px;
  color: #3E3E3E;
  display: block;
}
.member-name-ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 180px;
}
.email-ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 240px;
}
.member_img {
  display: table-cell;
  vertical-align: middle;
  padding-right: 15px;
}
.member-text {
  display: table-cell;
  word-break: break-all;
}
.mr-tp-20 {
  margin-top: 20px;
}
.mr-bt-10 {
  margin-bottom: 4px;
}
.mr-tp-10 {
  margin-top: 10px;
}
.mr-bt-5p {
  margin-bottom: 5%;
}
.info-tabs >>> .el-tabs__active-bar {
  height: 6px;
}
.info-tabs >>> .el-tabs__item {
  font-size: 16px;
}
.info-header {
  font-weight: 600;
  font-size: 16px;
  color: #3E3E3E;
}
.info-text {
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  margin-bottom: 10px;
  color: rgba(0, 0, 0, 0.7);
  text-align: left;
  word-break: break-word;
}
.info-img {
  height: 18px;
  width: 18px;
}
.edit-delete-img {
  height: 18px;
  width: 18px;
  /* margin-top: 8px; */
}
.modal-header .close {
  background: unset;
  opacity: 1;
  line-height: unset;
  width: unset;
  border-radius: unset;
  color: unset;
  font-weight: 300;
  font-size: 30px;
}
.cursor-not-allowed {
  cursor: not-allowed !important;
}

.confirm-body {
  font-size: 14px;
  padding: 15px;
}
.btn-width-confirm {
  width: 100px;
}
#container {
  height: 100%;
}
#add-team-footer {
  padding-bottom: 30px;
}
.header-team {
  padding: 15px 0px 0px 0px;
  font-size: 28px;
  line-height: 33px;
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 300;
}
.icon-close {
  color: #333333 !important;
}
.el-icon-close{
  opacity: 0.7 !important;
}
.add-border {
  width: 100%;
  border: 0.5px solid #828282;
  box-sizing: border-box;
  border-radius: 20px;
}
.add-dropdown-img {
  -webkit-appearance: none;
  appearance: none;
  background: url("/static/images/icons/chevron_down_grey.svg") no-repeat right white;
  background-position: 99% 50%;
}

#add-team-footer {
  padding-top: 10px;
}
.custo-search >>> .el-input__inner {
  padding-left: 34px !important;
  border: 0.5px solid #828282;
  box-sizing: border-box;
  border-radius: 20px;
}
.pd-lt-0 {
  padding-left: 10px;
}
.pd-rt-0 {
  padding-right: 0px;
}
.text-alg-center {
  text-align: center;
}
.float-right {
  float: right;
}
.mr-lt-33 {
  margin-left: 33px;
}
.member-box-wrapper:last-child {
  border-bottom: none;
}
.member-box-wrapper {
  /* padding-top: 14px;
  padding-bottom: 14px; */
  padding: 14px 0;
  margin:0;
}
.ptb-6 {
  padding: 9px 0 !important;
}
.dotted .member-box-wrapper:first-child {
  /* border-bottom: 1px dashed #333333; */
  /* opacity: 0.6; */
  background: #E6E6E6 !important;
  padding: 14px 0 12px 0;
  height: 48px;
}
.member-box-wrapper i{
  color: #0b3c61;
}
.el-select-dropdown__item.selected {
  color: #0b3c61;
}
.checkbox {
  position: relative;
}
input[type="checkbox"] {
  opacity: 0;
  cursor: pointer;
  position: absolute;
  z-index: 1;
  width: 15px !important;
  height: 15px !important;
  left: 0;
  top: 0;
  margin: 0 !important;
}
.checkbox label:before {
  content: "";
  width: 14px !important;
  height: 14px !important;
  border: 1px solid #0b3c61;
  display: inline-block;
  position: absolute;
  left: 0;
  top: 0;
}
.checkbox.cust_checkbox input[type="checkbox"]:disabled + label:before{
  border: 1px solid #828282;
  opacity: 0.5;
}
.checkbox input[type="checkbox"]:checked + label:before {
  background-color: #0b3c61;
  background-image: url(/static/images/icons/checkbox.svg);
  background-size: 10px 12px;
  background-repeat: no-repeat;
  background-position-x: center;
}
.checkbox label {
  cursor: auto;
  top: 5px;
  position: relative;
}
.cust_checkbox {
  margin: 0px;
  margin-right: 8px;
  display: inline-block;
}
.confirmpopup-bgcolor {
  background-color: #ffffff;
}
.footer {
  padding-top: 10px;
  position: absolute;
  bottom: 0%;
  padding-bottom: 2%;
  right: 0;
  background-color: #fff;
}
.add_icon_img {
  display: none;
}
.custo-search >>> .el-input__icon {
  font-size: 22px;
  font-weight: 600;
  color: #828282;
}
.reset-close-xs {
  display: none;
  top: 8px;
  right: 12%;
}
@media only screen and (min-width: 1301px) {
  .remove_button_padding {
    padding-left: 230px;
  }
}
@media (width: 1024px) and (height: 768px){
  .container1 {
    max-height: calc(84vh - 476px)!important;
  }
}
@media screen and (width: 768px) {
  .container1 {
    max-height: calc(84vh - 100px)!important;
  }
}
/* @media screen and (min-width: 1025px) and (max-width: 1300px){
  .container1 {
    max-height: calc(84vh - 330px)!important;
  }
} */
@media screen and (max-width: 1300px) {
  .container1 {
    padding-left: 0px;
    padding-right: 0px;
    /* margin-top: 272px; */
  }
}
@media screen and (max-width: 767px) {
  .bt-border{
    padding-bottom: 10px;
  }
  .hide-xs {
    display: none;
  }
  .container1 {
    margin-top: 290px;
    max-height: calc(90vh - 100px);
  }
  .add_icon_img {
    display: inline !important;
  }
  .search-reset-label {
    display: none;
  }
  .reset-close-xs {
    display: block;
  }
  .arrow-disp {
    display: table-cell !important;
    vertical-align: middle;
  }
  .member-text {
    width: 96%;
  }
  .xs-pd-lt-0 {
    padding-left: 0px;
  }
  .xs-pd-rt-0 {
    padding-right: 0px;
  }
  .xs-mr-bt-10 {
    margin-bottom: 10px;
  }
  .footer {
    padding-bottom: 5%;
  }
}
@media (min-width: 1025px) and (max-width: 1280px) {
 .custo-search >>> .el-input__inner {
    border: 1px solid #828282 !important;
 }
}
@media screen and (max-width: 320px){
  .switch{
    margin-left: 8px;
  }
}
/* iphoneX landscape  */
@media (device-width: 812px) and (device-height: 375px){
  .container1 {
    margin-top: 225px;
    max-height: 17vh;
  }
  .footer {
    padding-bottom: 1%;
  }
  .mr-bt-10 {
    margin-bottom: 0px!important;
  }
  .mr-tp-10 {
    margin-top: 0px!important;
  }
  .member-box-wrapper{
    padding-top: 0px;
  }
}
/* iphone5 landscape and below */
@media (max-width: 640px) and (max-height: 360px){
  .container1 {
    margin-top: 190px;
    max-height: 15vh;
  }
  .footer {
    padding-bottom: 0%;
  }
}
/* iphone 6 and 6+ landscape  */
@media (device-width: 736px) and (device-height: 414px), (device-width: 667px) and (device-height: 375px){
  .container1 {
    margin-top: 200px;
    max-height: 25vh;
  }
  .footer {
    padding-bottom: 0%;
  }
}
@media screen and (max-width: 610px) {
  .team_member_count {
    padding: 58px 5px 20px 5px;
  }
  .team_member_found {
    width: 90%;
    text-align: center;
  }
  .d-flex-sm-end {
    width: 90%;
    padding-left: 10px;
  }
  .mb-5, .add_team_member, .add_member_and_tooltip, .pl-34 {
    padding: 0;
    margin: 0;
  }
}
</style>
